import AppClient from "../utils/http-client/app-client"
import {
  LoginRecordRequestBody,
  StatementServiceCheckCardEligibleRequestBody,
  StatementServiceCheckStatementResponseBody,
  StatementServiceGetStatementDetailResponseBody,
  StatementServiceGetStatementByUuidRequestBody,
  ValidateLoginRequestBody,
  ValidateLoginResponseBody,
  BypassLoginRequestBody,
  BypassLoginResponseBody,
} from "../utils/type/login.type"
import { ApiResponse } from "../utils/type/api-response.type"

export const existByUuid = (
  statementUuid: string
): ApiResponse<StatementServiceCheckStatementResponseBody> => {
  return AppClient.get(`/api/v1/statements/${statementUuid}`)
}

export const getStatementByUuid = (
  requestBody: StatementServiceGetStatementByUuidRequestBody
): ApiResponse<StatementServiceGetStatementDetailResponseBody> => {
  return AppClient.post(`/api/v1/statements/${requestBody.uuid}`, {
    nationalId: requestBody.requestBody.nationalId,
    dateOfBirth: requestBody.requestBody.dateOfBirth,
  })
}

export const checkCardEligible = (
  requestBody: StatementServiceCheckCardEligibleRequestBody
): ApiResponse<boolean> => {
  return AppClient.post(`/api/v1/statements/check-card-eligible`, {
    uuid: requestBody.uuid,
  })
}

export const createLoginRecord = (
  requestBody: LoginRecordRequestBody
): ApiResponse<BigInteger> => {
  return AppClient.post("/api/v1/login", {
    nationalId: requestBody.nationalId,
    lastKey: requestBody.lastKey,
  })
}

export const validateLoginCredential = (
  requestBody: ValidateLoginRequestBody
): ApiResponse<ValidateLoginResponseBody> => {
  return AppClient.post("/api/v1/statements/check-login", {
    uuid: requestBody.uuid,
    nationalId: requestBody.nationalId,
    dateOfBirth: requestBody.dateOfBirth,
    lastKey: requestBody.captchaKey,
    inputCode: requestBody.inputCode,
  })
}

export const byPassLogin = (
  requestBody: BypassLoginRequestBody
): ApiResponse<BypassLoginResponseBody> => {
  return AppClient.post(`/api/v1/statements/bypass-login`, {
    uuid: requestBody.uuid,
    succeedUuid: requestBody.succeedUuid,
    recordId: requestBody.recordId,
  })
}
